export default () => {
  // return "https://sales-api.jombiz.store"; //prod api url

  return "https://jombiz-api-uat.techbasemlm.com" //uat api url
  // return " https://sales-api.jommall.com" //prod api url
};
